<p class="warning">{{ data }}</p>
<div fxLayoutAlign="center center">
  <button mat-stroked-button (click)="close()">No</button>
  <button mat-flat-button color="primary" (click)="confirm()">Yes</button>
</div>
